import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button, Alert } from "react-bootstrap";

import PlaylistsTableComponent from "../../../components/playlists/PlaylistsTableComponent.jsx";

import { useModal } from "../../../hooks/useModal.jsx";
import Loader from "../../../components/widgets/Loader.jsx";
import useCustomGetStoreState from "../../../hooks/useCustomGetStoreState.jsx";
import useSearchWithParams from "../../../hooks/useSearchWithParams.jsx";

import HelperMetiers360 from "../../../services/HelpersMetiers360.js";
import UpdateVideoPlaylistsComponent from './UpdateVideoPlaylistsComponent.jsx';

const VideoDetailsPlaylists = (props) => {

    const { video} = props;

    const { modalComponent, setModalShow, modalData, setModalData } = useModal();

    const { allPlaylists, isFetchingPlaylists } = useCustomGetStoreState('playlists');

    const [filteredPlaylists, setFilteredPlaylists] = useState([]);
    const [videoPlaylists, setVideoPlaylists] = useState([]);
     const uploadFormRef = useRef(null);

    useEffect(() => {
      const videoPlaylists = allPlaylists.filter(playlist =>
        playlist.videos?.some(playlistVideoUUID => playlistVideoUUID === video.uniqueId)
      );
    
      setFilteredPlaylists(videoPlaylists);
      setVideoPlaylists(videoPlaylists);
    }, [allPlaylists, video]);
    
    const { searchInput, search } = useSearchWithParams({
      placeholder: 'Rechercher par mots-clés (nom, établissement, créée par...)',
      delay: 400,
    });
    
    useEffect(() => {
        if(videoPlaylists.length > 0) {
            const searchedPlaylists = videoPlaylists.filter(
                playlist =>
                HelperMetiers360.isSearchInText(search, playlist.name) ||
                HelperMetiers360.isSearchInText(search, playlist.client?.name) ||
                HelperMetiers360.isSearchInText(search, playlist.owner?.username)
            );
            setFilteredPlaylists(searchedPlaylists);
        }
    }, [search, allPlaylists, video]);


    if(isFetchingPlaylists) {
        return <Loader />;
    }


    const NameForm = <UpdateVideoPlaylistsComponent video={video} videoPlaylists={videoPlaylists} ref={uploadFormRef} closeModal={() => setModalShow(false)} />;


    const onUpdatePlaylists = () => {
        setModalData({
            ...modalData,
            header:"Modification des playlists",
            content:NameForm,
            cancelButton: 'Annuler',
            onValidate: () => {
                uploadFormRef.current?.submitForm();
            },
            size: 'xl'
        });
        setModalShow(true);
    }

    const updatePlaylistsButton = (
        <Button
            variant={videoPlaylists.length === 0 ? "success" : "secondary"}
            onClick={onUpdatePlaylists}
        >
            <i className={`fas ${videoPlaylists.length === 0 ? "fa-plus" : "fa-edit"}`}></i>
            &nbsp;{videoPlaylists.length === 0 ? "Ajouter" : "Modifier"}
        </Button>
    );


    const isNoResult = !isFetchingPlaylists && videoPlaylists.length !== 0 && filteredPlaylists.length === 0;
    const isNoPLaylist = !isFetchingPlaylists && !videoPlaylists.length

    return <Container fluid>
            <Row>
                <Col>
                <h2 className="d-flex">
                    Playlists contenant la video : {video.videoName}
                </h2>
                </Col>
            </Row>
            <Row className="item-page">
            {videoPlaylists.length > 0 &&
                <Col>
                    {searchInput}
                </Col>
            }
            <Col className={videoPlaylists.length > 0 ? "d-flex justify-content-end align-items-center" : "d-flex justify-content-center align-items-center"}>
                    {updatePlaylistsButton}
                </Col>
            </Row>
            {isNoResult && <Alert className="mt-3" variant="warning"> Aucune playlist ne correspond à votre recherche</Alert>}
        {isNoPLaylist && <Alert className="mt-3" variant="warning">La video n'est contenue dans aucune playlist</Alert>}
            {
                filteredPlaylists.length > 0 && 
            <PlaylistsTableComponent playlists={filteredPlaylists} />
            }
            {(isFetchingPlaylists) && <Loader />}
            <>{modalComponent}</>
    </Container>;
}

export default VideoDetailsPlaylists;